import { useState } from 'react';
import { useDispatch } from 'react-redux';

import { patchUserSettings } from 'actions/user';
import Button from 'atoms/button';
import Dropdown from 'atoms/dropdown';
import toast from 'atoms/toast';
import { editMaxConcurrency } from 'store/reducers/entitySettings';

export default function MaxBookings({ maxConcurrency, uuid }) {
  const dispatch = useDispatch();
  const onSave = () => {
    dispatch(patchUserSettings({ uuid, body: { maxConcurrency } })).then(
      ({ success }) => {
        if (success) toast({ text: 'Your settings have been updated' });
      }
    );
  };
  return (
    <div className="flex-column mt-12 p-24 border-light-purple radius-24">
      <h4 className="mb-8">Maximum bookings per slot</h4>
      <p className="f13 mb-15">
        How many appointments do you want to allow per time slot
      </p>
      <Dropdown
        id="concurrency"
        size="small"
        variant="white"
        items={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10]}
        value={maxConcurrency}
        onClick={(value) => dispatch(editMaxConcurrency(value))}
      />
      <Button
        size="small"
        text="Save"
        onClick={onSave}
        className="flex-row w-fit mt-12"
      />
    </div>
  );
}
